import { render, staticRenderFns } from "./PageRow.vue?vue&type=template&id=1fa83dc2&scoped=true"
import script from "./PageRow.vue?vue&type=script&lang=js"
export * from "./PageRow.vue?vue&type=script&lang=js"
import style0 from "./PageRow.vue?vue&type=style&index=0&id=1fa83dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa83dc2",
  null
  
)

export default component.exports